import React from 'react';
import { Alert, Button, Snackbar } from '@mui/material';
import { BRAND_GOLD } from '../navigation/navTabStyles';

type UpdateAvailableBannerProps = {
  open: boolean;
  onUpdate: () => void;
};

const UpdateAvailableBanner = ({ open, onUpdate }: UpdateAvailableBannerProps) => (
  <Snackbar
    open={open}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    sx={{ mb: 2 }}
  >
    <Alert
      severity="warning"
      variant="filled"
      action={
        <Button color="inherit" size="small" onClick={onUpdate} sx={{ fontWeight: 700 }}>
          Update
        </Button>
      }
      sx={{
        alignItems: 'center',
        bgcolor: BRAND_GOLD,
        color: 'grey.900',
        fontWeight: 600,
        '& .MuiAlert-icon': { color: 'grey.900' },
      }}
    >
      A new version of Endchess is available.
    </Alert>
  </Snackbar>
);

export default UpdateAvailableBanner;
